<template>
  <el-row>
    <el-col>
      <el-card>
        <el-row>
          <el-col>
            <el-tabs v-model="activeTab">
              <el-tab-pane name="Oportunidades" label="Oportunidades">
                <DealsProspectingKpiVue />
              </el-tab-pane>

              <el-tab-pane name="Presentaciones" label="Presentaciones">
                <DealsPresentationsKpiVue />
              </el-tab-pane>

              <el-tab-pane name="Closing" label="Cerradas">
                <DealsClosesKPIVue />
              </el-tab-pane>

              <el-tab-pane name="Ventas" label="Ventas">
                <DealsKpiVue />
              </el-tab-pane>
            </el-tabs>
          </el-col>
        </el-row>
      </el-card>
    </el-col>
  </el-row>
</template>

<script>
import DealsClosesKPIVue from "./DealsClosesKPI.vue";
import DealsProspectingKpiVue from "./DealsProspectingKpi.vue";
import DealsPresentationsKpiVue from "./DealsPresentationsKpi.vue";
import DealsKpiVue from "./DealsKpi.vue";

export default {
  data() {
    return {
      activeTab: "Oportunidades"
    };
  },

  components: {
    DealsProspectingKpiVue,
    DealsClosesKPIVue,
    DealsPresentationsKpiVue,
    DealsKpiVue
  }
};
</script>

<style></style>
